import { render, staticRenderFns } from "./EmployeeWorld.vue?vue&type=template&id=097478a0&"
import script from "./EmployeeWorld.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports